import { appConfigConstant } from './appEnvConstant'

export const BASE_URL = appConfigConstant?.MASTER_DATA_API_BASE_URL

export const BASE_URL_WITHOUT_MASTER_DATA = appConfigConstant?.WITHOUT_MASTER_DATA_API_BASE_URL

export const IMPORT_REQUEST_SERVICE = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/program/import-request`

export const PROGRAM_SERVICE = `${BASE_URL}/program`

export const GENERATIONS_SERVICE = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/program/generations`

export const SEED_CLASSIFICATION_SERVICE = `${BASE_URL}/program`

export const VARIETY_SERVICE = `${appConfigConstant?.WITHOUT_MASTER_DATA_API_BASE_URL}/varieties/program`

export const DEMAND_POINT_SERVICE = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/program/demand-details/program/`

export const USERS_SERVICE = `${BASE_URL}/program`

export const USER_ROLES = `${BASE_URL}/dropdown/roles`

export const USER_PROGRAMS = `${BASE_URL}/dropdown/programs`

export const ALLOCATION_SERVICE = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL}`
export const INITIAL_ALLOCATION_EXECUTE = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL}/initial-allocation/execute`
export const ALLOCATION_SERVICE_V2 = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V2}`
export const CONTRACT_SUMMARY_SERVICE = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/contract-summary/program`
export const ALLOCATION_SUMMARY_FILTER_SERVICE = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/allocations-summary`
export const SHIPMENT_SUMMARY_SERVICE = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/shipment-summary`
export const ALLOCATION_SUMMARY_SEND_EMAIL_SERVICE = `${ALLOCATION_SUMMARY_FILTER_SERVICE}/email/program/`
export const ALLOCATION_SUMMARY_DOWNLOAD_SERVICE = `${ALLOCATION_SERVICE}-reports/program/`
export const SHIPMENT_SUMMARY_EMAIL_SERVICE = `${SHIPMENT_SUMMARY_SERVICE}/email/program/`
export const SHIPMENT_SUMMARY_DOWNLOAD_SERVICE = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/shipment-reports/download/program/`
export const SUPPLIER_EMAILS_SERVICE = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/supply-actuals/get-email-contacts`

export const GET_VARIETIES = `${ALLOCATION_SERVICE}/variety/details`
export const UPDATE_ALLOCATION = `${ALLOCATION_SERVICE}`
export const RECEIVER_DEMAND_UPDATE = `${ALLOCATION_SERVICE}/receiver/demand`
export const DISPOSAL_DESTINATION = `${ALLOCATION_SERVICE}/receiver/disposal-destinations`
export const SOURCE_SUPPLIER = `${ALLOCATION_SERVICE}/supplier`
export const SOURCE_SUPPLIER_V2 = `${ALLOCATION_SERVICE_V2}/supplier`

export const ADD_SOURCE_SUPPLIER = `ADD_SOURCE_SUPPLIER`
export const DISPOSAL = `DISPOSAL`
export const DISPOSAL_DROPDOWN_VALUE = `Disposal`
export const SUPPLIER_REPORT = `${ALLOCATION_SERVICE}/supplier/report`
export const DOMESTIC_ALLOCATION_PDF_API = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/allocation-details/download/allocation-form-pdf`
export const IMPORT_ALLOCATION_PDF_API = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/allocation-details/receiver`
export const UPLOAD_ALLOCATION_PDF = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/allocation-details/upload/allocation-form-pdf`
export const RECEIVER_REPORT = `${ALLOCATION_SERVICE}/receiver/report`
export const DOWNLOAD_SUPPLIER_REPORT = `${ALLOCATION_SERVICE}/supplier/report/download`
export const DOWNLOAD_RECEIVER_REPORT = `${ALLOCATION_SERVICE}/receiver/report/download`
export const VERIETIES_SERVICE = `${BASE_URL}/varieties`

export const SUPPLIER_SERVICE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/`

export const GROWER_SERVICE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/grower`

export const PLANNING_HORIZON_EXCEPTION_SERVICE = `${BASE_URL}/planning-horizon-exception`

export const GENERAL_SETTINGS = `${appConfigConstant?.WITHOUT_MASTER_DATA_API_BASE_URL}/program/general-settings`

export const SEED_CLASSIFICATION_EXCEPTION_SERVICE = `${BASE_URL}/seed-classification-exception/`

export const SIZE_SPLIT_EXCEPTION_SERVICE = `${BASE_URL}/program/`

export const CROP_CYCLE_DEFINITION_SERVICE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program/`

export const CROP_CYCLE_SUPPLIER = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/supplier`

export const POTATO_TYPES = `${BASE_URL}/program/potato-types`
export const POTATO_TYPES_ALLOCATION = `${BASE_URL}/program`

export const REQUEST_SUMMARY_FILTER_SERVICE = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/program/import-request/request-type`

export const CODE_BY_CATEGORY = `${appConfigConstant?.WITHOUT_MASTER_DATA_API_BASE_URL}/units-of-measurement/codes-by-category`

export const CODE_BY_CATEGORIES = `${appConfigConstant?.WITHOUT_MASTER_DATA_API_BASE_URL}/units-of-measurement/codes-by-categories`

export const CURRENCY_CODE = `${appConfigConstant?.WITHOUT_MASTER_DATA_API_BASE_URL}/program/currency-codes`

export const CROP_CYCLE_MANAGEMENT_PRICING_SERVICE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program/crop-cycle-pricing/`

export const CROP_CYCLE_MANAGEMENT_PRICING_PROGRAM_SERVICE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/programs/`

export const UPDATE_GENERAL_SETTING = `${BASE_URL}/program/general-settings`

export const CROP_CYCLE_MANAGEMENT_CONVERSION_RATE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program/cropcyclemanagementplanlet/plantlets`

export const CROP_CYCLE_MANAGEMENT_CONVERSION_RATE_SEED = `${appConfigConstant?.WITHOUT_CROP_CYCLE_API_BASE_URL}/crop-cycle-management/`

export const CONVERSION_RATE_BULK = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/conversion-rates/bulk`

export const DEMAND_STRATEGY_PROGRAM = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/program`

export const USER_SERVICE = `${BASE_URL}/program`

export const CROP_CYCLE_MANAGEMENT_CONVERSION_RATE_PLANTLETS_POST = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program/cropcyclemanagementplanlet`

export const VARIETY_STRATERGY = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/varietystrategy/varietystrategies/program`

export const CREATE_VARIETY = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/varietystrategy/varietystrategies/varieties`

export const DEMAND_STRATEGY = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}`

export const DEMAND_STRATEGY_VARIETIES = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}`

export const VARIETY_LOCAL_NAMES = `${appConfigConstant?.WITHOUT_MASTER_DATA_API_BASE_URL}/varieties/program`

export const VARIETY_TYPE = `${appConfigConstant?.WITHOUT_MASTER_DATA_API_BASE_URL}/varieties`

export const DEMAND_POINTS_PROGRAM = `${DEMAND_STRATEGY_PROGRAM}/demand-points/program/`

export const EXPORT_DEMAND_POINTS_PROGRAM = `${DEMAND_STRATEGY_PROGRAM}/demand-points/export/program/`

export const DEMAND_DETAILS_STRATEGY = `${DEMAND_STRATEGY_PROGRAM}/demand-details/demandStrategy`

export const UPDATE_DEMAND_STRATERGY = `${DEMAND_STRATEGY_PROGRAM}/demand-strategy/`

export const DELETE_DEMAND_POINT = `${DEMAND_STRATEGY_PROGRAM}/demand-points/program/`

export const CROP_CYCLE_BY_PROGRAM = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program/cropcycles/`

export const SOURCING_STRATEGY = `${BASE_URL}/varietysourcingstrategy/`

export const SIZE_SPLIT_API = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/crop-cycle-management/size-splits`

export const SIZE_SPLITS_SERVICE = `${BASE_URL_WITHOUT_MASTER_DATA}/masterdata/program`

export const SIZE_RANGES_SERVICE = `${BASE_URL_WITHOUT_MASTER_DATA}/masterdata/program`

export const SUPPLIER_BY_PROGRAM = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program`

export const BROKER_BY_PROGRAM = `${appConfigConstant?.MASTER_DATA_API_BASE_URL}/program`

export const DEMAND_ACTUALS_SERVICE = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v2/demandactuals/`

export const DEMAND_ACTUALS_SERVICE_V1 = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v1/demandactuals/`

export const DEMAND_STRATEGY_VARIETY_API_STRATEGY_BASE_URL = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/varietystrategy/varietystrategies/demandstrategy`

export const DEMAND_STRATEGY_CURRENT_PLANNING_YEAR_BASE_URL = `${appConfigConstant?.DEMAND_STRATEGY_API_BASE_URL}/planning-year/current`

export const SUPPLY_ACTUALS_BASE_URL = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}`

export const SUPPLY_ACTUALS_SUPPLY_DETAILS = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}/supplier/details`

export const SUPPLY_ACTUALS_SUPPLY_SUMMARY = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}/supplier/summary`

export const SUPPLY_ACTUALS_SUPPLY_SUMMARY_FILTERS = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}/program`

export const SUPPLY_SUMMARY_SERVICE_BASE_URL = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/supply-summary/program`

export const SUPPLY_DETAILS_FILTER_SERVICE_BASE_URL = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/supply-details/program`

export const SUPPLY_ACTUALS_ADD_ROW = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}/addRow`

export const SUPPLY_ACTUALS_ADD_ROW_V2 = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL?.replace('/api/v1/', '/api/v2/')}/addRow`

export const SUPPLY_ACTUALS_CONTINUE_ADD_ROW = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}/continueToAddRow`

export const UPDATE_SUPPLY_ACTUALS = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}`

export const DELETE_SUPPLY_ACTUALS = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}`

export const GET_CLASSIFICATION_GRADE = `${appConfigConstant?.SUPPLY_ACTUALS_SERVICE_BASE_URL}/classification-grades`

export const SUPPLY_REBALANCE_SUPPLIER = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/supply-rebalance/rebalance-supplier`

export const SUPPLY_REBALANCE_PROGRAM = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/supply-rebalance/rebalance-program`

export const DEFAULT_USER_ID = '1'

export const DATE_PLACEHOLDER = '0000-00-00'

export const ALLOCATION_TYPE_SERVICE = `${ALLOCATION_SERVICE}/allocation-types`

export const VERIETIES_SERVICE_BY_PROGRAM = `${BASE_URL_WITHOUT_MASTER_DATA}/varieties/program`

export const CROP_CYCLE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program/cropcycles`

export const SOURCE_DESTINATION_CROP_CYCLE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program`

export const CROP_CYCLE_POTATO_TYPE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/program/cropcycles/potatotype`

export const GET_VARIETY_TOTALS = `${ALLOCATION_SERVICE}/variety/totals`

export const CONTRACT_SERVICE = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v1/contracts`

export const OUTPUT_SEED_URL = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v1/contracts/outputSeed`

export const TOTAL_INPUT_SEED = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v1/contracts/totalOutputSeed`

export const CONVERSTION_RATE = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/contracts/conversionRate`

export const PRICE_DETAILS = `${appConfigConstant?.CROP_CYCLE_API_BASE_URL}/contracts/priceDetails`

export const VUF_BASED_ON_OPTIONS = ['Quantity', 'Area']

export const ROLE_IDS_FOR_CTA_DISABLE = [1001]

export const SUMMARY_TYPES = [
  { id: 'supply', displayText: 'Supply Summary' },
  { id: 'financial', displayText: 'Financial Summary' },
]

export const LANDING_SERVICE = `${appConfigConstant?.LANDING_NOTIFICATIONS_BASE_URL}`

export const REDIRECT_LOGIN_URL = `${appConfigConstant?.LOGIN_REDIRECT_URL}`

export const FINANCIAL_SUMMARY_SERVICE = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v1/liability`
export const FINANCIAL_SUMMARY_DOWNLOAD_SERVICE = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v1/financial-summary`

export const GET_BASE_CONTRACT_URL = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v1/contracts`

export const GLOSSARY_SERVICE = `${appConfigConstant?.DEMAND_ACTUALS_API_BASE_URL}/gspt/api/v1/glossary/glossary?file-name=Help-Section-for-short-Forms.xlsx`

export const GET_ALLOCATION_TYPE = `${CONTRACT_SERVICE}/allocation-types`

export const ALLOCATION_DETAILS_API = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/allocation-details/program`
export const MANUAL_SUPPLY_API = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/allocation-details/receivers`

export const ALLOCATION_DETAILS_TOTALS = `${appConfigConstant?.ALLOCATION_DETAILS_SERVICE_BASE_URL}/program`
export const ALLOCATION_DETAILS_BASE_URL = `${appConfigConstant?.ALLOCATION_SERVICE_BASE_URL_V1}/allocation-details/program`

export const PAGINATION_START = 1

export const PAGINATION_PAGE_SIZE = 25

export const FINANCIAL_SUMMARY_TABS = [
  {
    label: 'Contract Liability',
    id: 'contractLiability',
    heading: 'Liability (Selected Year vs. Previous Year)',
  },
  {
    label: 'PepsiCo Owes to Supplier',
    id: 'pepsicoOwes',
    heading: 'PepsiCo Owes to Supplier (Selected Year vs. Previous Year)',
  },
  {
    label: 'Supplier Owes to PepsiCo',
    id: 'supplierOwes',
    heading: 'Supplier Owes to PepsiCo (Selected Year vs. Previous Year)',
  },
]

export const SUPPLY_SUPPLIERS_PAGE_SIZE = 5

export const SUPPLY_VIEW_ID_SUMMARY = 1

export const SUPPLY_VIEW_ID_DETAILS = 2

export const OPTION_DEMAND_ALLOCATION_TYPE_ID = 6

export const ALL_GENERATIONS_ID = '12'
export const MINITUBER_OUTPUT_GENERATION_ID = 1
export const OUTPUT_POTATO_TYPE_ID_MINITUBER = 1
export const OUTPUT_POTATO_TYPE_DISPLAY_TEXT_MINITUBER = 'minituber'
